export const LAMBDATEST_BUILD_DATA_LOADING = "LAMBDATEST_BUILD_DATA_LOADING";
export const LAMBDATEST_BUILD_DATA_SUCCESS = "LAMBDATEST_BUILD_DATA_SUCCESS";
export const LAMBDATEST_BUILD_DATA_FAILED = "LAMBDATEST_BUILD_DATA_FAILED";
export const LAMBDATEST_BUILD_DATA_CLEAR = "LAMBDATEST_BUILD_DATA_CLEAR";
export const LAMBDATEST_SET_PAGENO_WHILE_FETCHING =
  "LAMBDATEST_SET_PAGENO_WHILE_FETCHING";

export const LAMBDATEST_BUILD_TESTLIST_CLEAR =
  "LAMBDATEST_BUILD_TESTLIST_CLEAR";

export const LAMBDATEST_SET_BUILDID_WHILE_FETCHING =
  "LAMBDATEST_SET_BUILDID_WHILE_FETCHING";

export const LAMBDATEST_BUILD_DATA_FETCH_MORE_LOADING =
  "LAMBDATEST_BUILD_DATA_FETCH_MORE_LOADING";
export const LAMBDATEST_BUILD_DATA_FETCH_MORE_SUCCESS =
  "LAMBDATEST_BUILD_DATA_FETCH_MORE_SUCCESS";
export const LAMBDATEST_BUILD_DATA_FETCH_MORE_FAILED =
  "LAMBDATEST_BUILD_DATA_FETCH_MORE_FAILED";

export const LAMBDATEST_BUILD_DATA_SILENT_LOADING = `LAMBDATEST_BUILD_DATA_SILENT_LOADING`;
export const LAMBDATEST_BUILD_TESTLIST_SILENT_LOADING = `LAMBDATEST_BUILD_TESTLIST_SILENT_LOADING`;
export const LAMBDATEST_UPDATE_BUILDNAME_LOADING =
  "LAMBDATEST_UPDATE_BUILDNAME_LOADING";
export const LAMBDATEST_UPDATE_BUILDNAME_SUCCESS =
  "LAMBDATEST_UPDATE_BUILDNAME_SUCCESS";
export const LAMBDATEST_UPDATE_BUILDNAME_FAILED =
  "LAMBDATEST_UPDATE_BUILDNAME_FAILED";
export const LAMBDATEST_UPDATE_BUILDNAME_CLEAR =
  "LAMBDATEST_UPDATE_BUILDNAME_CLEAR";
export const LAMBDATEST_UPDATE_BUILD_DATA_LOADING =
  "LAMBDATEST_UPDATE_BUILD_DATA_LOADING";
export const LAMBDATEST_UPDATE_BUILD_DATA_SUCCESS =
  "LAMBDATEST_UPDATE_BUILD_DATA_SUCCESS";
export const LAMBDATEST_UPDATE_BUILD_DATA_FAILED =
  "LAMBDATEST_UPDATE_BUILD_DATA_FAILED";
export const LAMBDATEST_UPDATE_BUILD_FIELD = "LAMBDATEST_UPDATE_BUILD_FIELD";
export const SHOW_SAMPLE_BUILD = "SHOW_SAMPLE_BUILD";
export const LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_LOADING =
  "LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_LOADING";
export const LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_SUCCESS =
  "LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_SUCCESS";
export const LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_FAILED =
  "LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_FAILED";
export const LAMBDATEST_UPDATE_ACTIVE_BUILD_TAB =
  "LAMBDATEST_UPDATE_ACTIVE_BUILD_TAB";
export const LAMBDATEST_FILTER_BUILD_DATA_LOADING =
  "LAMBDATEST_FILTER_BUILD_DATA_LOADING";
export const LAMBDATEST_FILTER_BUILD_DATA_SUCCESS =
  "LAMBDATEST_FILTER_BUILD_DATA_SUCCESS";
export const LAMBDATEST_FILTER_BUILD_DATA_FAILED =
  "LAMBDATEST_FILTER_BUILD_DATA_FAILED";
export const SET_IS_BUILD_SELECTED_VIA_KEYBOARD =
  "SET_IS_BUILD_SELECTED_VIA_KEYBOARD";
export const LAMBDATEST_DELETE_BUILD_LOCAL = "LAMBDATEST_DELETE_BUILD_LOCAL";
export const LAMBDATEST_UPDATE_BUILD_LIST = "LAMBDATEST_UPDATE_BUILD_LIST";
